// extracted by mini-css-extract-plugin
export default {"container":"Caption_container__Xi+Oe","button":"Caption_button__hkDRo"};